import { getState } from '~src/state';
import { exportIMG } from '~core';

// previewCanvas è uno solo: due loadFromJSON sovrapposti (miniature della
// sidebar ed esportazioni) mescolerebbero le pagine, quindi passano in fila.
let queue = Promise.resolve();

const renderCanvasJson = (
  json,
  {
    quality = 0.92,
    outputDpi = 300,
    cleanBase64String = true,
    maxSize,
    imageFormat = 'jpeg',
    multiplier = 1,
  }
) => {
  return new Promise((resolve, reject) => {
    const previewCanvas = getState('previewCanvas');

    previewCanvas.loadFromJSON(json, async () => {
      try {
        const scale = maxSize
          ? maxSize /
            Math.max(previewCanvas.getWidth(), previewCanvas.getHeight())
          : multiplier;
        const preview = exportIMG(
          quality,
          outputDpi,
          'base64',
          imageFormat,
          cleanBase64String,
          scale,
          previewCanvas
        );

        previewCanvas.clear();
        resolve(preview);
      } catch (error) {
        previewCanvas.clear();
        reject(error);
      }
    });
  });
};

export const canvasJsonToImage = (json, options = {}) => {
  const preview = queue.then(() => renderCanvasJson(json, options));
  queue = preview.catch(() => {});
  return preview;
};

if (typeof window !== 'undefined') {
  window.canvasJsonToImage = canvasJsonToImage;
}
